/**
 * Fix IE rending problems
 */

import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";

import * as serviceWorker from "./serviceWorker";

import App from "./App";
/* eslint-disable-next-line */
import React from "react";
import ReactDOM from "react-dom";

ReactDOM.render(<App />, document.getElementById("root"));
serviceWorker.unregister();
